import MsDyn365 from '@msdyn365-commerce/core';

export const getPagePath = (): string => {
    return MsDyn365.isBrowser
        ? window.location.href.split(location.host)[1].includes('?')
            ? window.location.href.split(location.host)[1].split('?')[0]
            : window.location.href.split(location.host)[1]
        : '';
};